
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import EstimateForm from './components/EstimateForm';
import Footer from './components/Footer';
import AIChat from './components/AIChat';
import MobileStickyCall from './components/MobileStickyCall';

const App: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pb-24 md:pb-0">
        {/* Trust Bar Section */}
        <div className="bg-dark-gray dark:bg-black py-6 sm:py-8 border-b border-white/5">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
              {[
                { value: 'Licensed & Insured' },
                { value: 'Margate Experts' },
                { value: 'Fast Storm Repair' },
                { value: 'Insurance Help' }
              ].map((item, idx) => (
                <div key={idx} className="flex items-center justify-center md:justify-start gap-2 text-white">
                  <div className="w-1.5 h-1.5 bg-primary rounded-full shrink-0"></div>
                  <div className="flex flex-col">
                    <span className="font-bold text-[10px] sm:text-sm lg:text-base whitespace-nowrap tracking-tight uppercase sm:normal-case">{item.value}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Hero />
        <Services />
        <Process />
        <Testimonials />
        <EstimateForm />
      </main>

      <Footer />
      <AIChat />
      <MobileStickyCall />
    </div>
  );
};

export default App;
